import { v4 as uuidv4 } from 'uuid';

import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { Link } from '../../../../vtex-apps/Link/Link/default';
import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { StoreImageList } from '../../../../vtex-apps/store-image-list/StoreImageList/default';
import { ListContextRenderer } from '../../../../vtex-apps/list-context/ListContextRenderer/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function FooterDesktop() {
	return {
		componentName: 'FooterDesktop',
		componentId: uuidv4(),
		componentGroup: 'FooterDesktop',
		props: {
			mzTitle: 'MZ | Footer - Desktop',
			blockClass: 'footer-desktop-2',
		},
		variables,
		childrenComponents: [
			FlexLayoutRow(
				{
					blockClass: 'footer-desktop-2-newsletter',
					colSizing: 'auto',
					horizontalAlign: 'between',
				},
				[
					Image({
						src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046479085-JdNwrJt.png',
					}),
				],
			),
			FlexLayoutRow(
				{
					blockClass: 'footer-desktop-2-content',
				},
				[
					VisibilityLayout({ mzTitle: 'MZ | Menu A Loja (On/Off)' }, [
						FlexLayoutCol({}, [
							Menu({
								blockClass: 'footer-desktop-2-content__menu',
								orientation: 'vertical',
								items: [
									MenuItem({
										blockClass: 'footer-desktop-2-content__menu-item',
										highlight: true,
										itemProps: {
											href: '/#',
											text: 'A [nome loja]',
										},
									}).props,
									MenuItem({
										blockClass: 'footer-desktop-2-content__menu-item',
										itemProps: {
											href: '/#',
											text: 'Quem Somos',
										},
									}).props,
									MenuItem({
										blockClass: 'footer-desktop-2-content__menu-item',
										itemProps: {
											href: '/#',
											text: 'Como comprar no nosso site',
										},
									}).props,
									MenuItem({
										blockClass: 'footer-desktop-2-content__menu-item',
										itemProps: {
											href: '/#',
											text: 'Formas de Compra e Entrega',
										},
									}).props,
									MenuItem({
										blockClass: 'footer-desktop-2-content__menu-item',
										itemProps: {
											href: '/#',
											text: 'Política de Troca e Devolução',
										},
									}).props,
									MenuItem({
										blockClass: 'footer-desktop-2-content__menu-item',
										itemProps: {
											href: '/#',
											text: 'Política de Privacidade LGPD',
										},
									}).props,
									MenuItem({
										blockClass: 'footer-desktop-2-content__menu-item',
										itemProps: {
											type: 'internal',
											href: '/#',
											text: 'Fale Conosco',
										},
									}).props,
								],
							}),
						]),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Menu Sua Conta (On/Off)' }, [
						FlexLayoutCol({}, [
							Menu({
								blockClass: 'footer-desktop-2-content__menu',
								orientation: 'vertical',
								items: [
									MenuItem({
										blockClass: 'footer-desktop-2-content__menu-item',
										highlight: true,
										itemProps: {
											href: '/',
											text: 'Sua Conta',
										},
									}).props,
									MenuItem({
										blockClass: 'footer-desktop-2-content__menu-item',
										itemProps: {
											href: '/account',
											text: 'Minha Conta',
										},
									}).props,
									MenuItem({
										blockClass: 'footer-desktop-2-content__menu-item',
										itemProps: {
											href: '/account#/orders',
											text: 'Meus Pedidos',
										},
									}).props,
									MenuItem({
										blockClass: 'footer-desktop-2-content__menu-item',
										itemProps: {
											href: '/#',
											text: 'Meus Favoritos',
										},
									}).props,
									MenuItem({
										blockClass: 'footer-desktop-2-content__menu-item',
										itemProps: {
											href: '/#',
											text: 'Notificação por email',
										},
									}).props,
								],
							}),
						]),
					]),
					FlexLayoutCol(
						{
							blockClass: 'footer-desktop-2-content__col',
						},
						[
							FlexLayoutRow(
								{
									blockClass: 'footer-desktop-2__atend-social',
								},
								[
									VisibilityLayout({ mzTitle: 'MZ | Menu Atendimento (On/Off)' }, [
										FlexLayoutCol({}, [
											RichText({
												text: '**Atendimento**',
												blockClass: 'footer-desktop-2-content__title',
												textAlignment: 'left',
												textPosition: 'left',
											}),
											RichText({
												text: 'De segunda a sexta, das 9h as 18h.',
												blockClass: 'footer-desktop-2-content__atendimento',
												textAlignment: 'left',
												textPosition: 'left',
											}),
											RichText({
												text: 'Telefones: **(00) 0000-0000 / (00) 0 0000-0000**',
												blockClass: 'footer-desktop-2-content__atendimento',
												textAlignment: 'left',
												textPosition: 'left',
											}),
											RichText({
												text: 'E-mail: [contato@nomeloja.com.br](mailto:contato@nomeloja.com.br)',
												blockClass: 'footer-desktop-2-content__atendimento',
												textAlignment: 'left',
												textPosition: 'left',
											}),
										]),
									]),
									VisibilityLayout({ mzTitle: 'MZ | Redes Sociais (On/Off)' }, [
										FlexLayoutCol({}, [
											RichText({
												text: '**Nossas Redes Sociais**',
												textAlignment: 'left',
												textPosition: 'left',
												blockClass: 'footer-desktop-2-content__title',
											}),
											FlexLayoutRow(
												{
													horizontalAlign: 'left',
													colSizing: 'auto',
													blockClass: 'footer-desktop-2-social-icons',
												},
												[
													StoreImageList(
														{
															images: [
																{
																	description: 'Facebook',
																	src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046717711-212365083-5b98cc81-5847-402a-9ab8-290df2ccb242.png',
																	link: {
																		url: 'https://www.facebook.com/',
																		newTab: true,
																	},
																},
																{
																	description: 'Instagram',
																	src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046730547-212365091-d67ff0ac-e491-4e2b-bee6-087f6eb20031.png',
																	link: {
																		url: 'https://www.instagram.com/',
																		newTab: true,
																	},
																},
																{
																	description: 'Twitter',
																	src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046743459-212365094-c5cd4039-4f34-42e6-9115-e6c034297413.png',
																	link: {
																		url: 'https://twitter.com/',
																		newTab: true,
																	},
																},
																{
																	alt: 'TikTok',
																	src: 'https://hefesto-upload-images.s3.amazonaws.com/1693331955678-tiktok.png',
																	link: {
																		url: 'https://tiktok.com/',
																		newTab: true,
																	},
																},
															],
														},
														[
															ListContextRenderer({
																blockClass: 'footer-desktop-2-social-icons__list',
																listElement: 'ul',
																itemElement: 'li',
															}),
														],
													),
												],
											),
										]),
									]),
								],
							),
						],
					),
					FlexLayoutCol(
						{
							blockClass: 'footer-desktop-2-content__col',
						},
						[
							FlexLayoutRow({ blockClass: 'footer-desktop-2__payment-security' }, [
								VisibilityLayout({ mzTitle: 'MZ | Formas de Pagamento (On/Off)' }, [
									FlexLayoutCol({}, [
										RichText({
											text: '**Formas de pagamento e bandeiras aceitas**',
											blockClass: 'footer-desktop-2-content__title',
											textAlignment: 'left',
											textPosition: 'left',
										}),
										FlexLayoutRow(
											{
												colSizing: 'auto',
												horizontalAlign: 'left',
												blockClass: 'footer-desktop-2-payment-logo',
											},
											[
												StoreImageList(
													{
														height: 40,
														images: [
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-mastercard.png',
																alt: 'MasterCard',
																title: 'MasterCard',
															},
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-visa.png',
																alt: 'Visa',
																title: 'Visa',
															},
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-hipercard.png',
																alt: 'Hipercard',
																title: 'Hipercard',
															},
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-hiper.png',
																alt: 'Hiper',
																title: 'Hiper',
															},
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-dinersclub.png',
																alt: 'Diners Club',
																title: 'Diners Club',
															},
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-jcb.png',
																alt: 'JCB',
																title: 'JCB',
															},
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-discover.png',
																alt: 'Discover',
																title: 'Discover',
															},
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-elo.png',
																alt: 'Elo',
																title: 'Elo',
															},
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-boleto.png',
																alt: 'Boleto',
																title: 'Boleto',
															},
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-pix.png',
																alt: 'Pix',
																title: 'Pix',
															},
														],
													},
													[
														ListContextRenderer({
															blockClass: 'footer-desktop-2-payment__list',
															listElement: 'ul',
															itemElement: 'li',
														}),
													],
												),
											],
										),
									]),
								]),
								VisibilityLayout({ mzTitle: 'MZ | Selos de Segurança (On/Off)' }, [
									FlexLayoutCol({}, [
										RichText({
											text: '**Selos de segurança**',
											blockClass: 'footer-desktop-2-content__title',
											textAlignment: 'left',
											textPosition: 'left',
										}),
										FlexLayoutRow(
											{
												blockClass: 'footer-desktop-2--high',
												fullWidth: true,
												paddingTop: 0,
												paddingBottom: 0,
												marginTop: 0,
												marginBottom: 0,
												colSizing: 'auto',
												horizontalAlign: 'left',
											},
											[
												StoreImageList(
													{
														height: 56,
														images: [
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318216942-eureciclo.png',
																alt: 'Eureciclo',
																title: 'SeloEu Reciclo',
																link: {
																	url: '',
																},
															},
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318175602-ebit.png',
																alt: 'Ebit',
																title: 'Selo Ebit',
																link: {
																	url: '',
																},
															},
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318302329-lets-encrypt.png',
																alt: 'Let`s Encript',
																title: 'Selo Let`s Encript',
																link: {
																	url: '',
																},
															},
														],
													},
													[
														ListContextRenderer({
															blockClass: 'footer-desktop-2-security__flags',
															listElement: 'ul',
															itemElement: 'li',
														}),
													],
												),
											],
										),
									]),
								]),
							]),
						],
					),
				],
			),
			VisibilityLayout({ mzTitle: 'MZ | Texto SEO (On/Off)' }, [
				FlexLayoutRow(
					{
						blockClass: 'footer-desktop-2-description',
					},
					[
						FlexLayoutCol({ horizontalAlign: 'center' }, [
							RichText({
								textAlignment: 'left',
								textPosition: 'CENTER',
								text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Malesuada quis sit massa rutrum vestibulum. Consequat neque, sit mattis rutrum ullamcorper in lectus adipiscing. Nisl, natoque mauris lectus cursus. Felis tristique quis faucibus mauris et id massa nulla. Condimentum...',
								blockClass: 'footer-desktop-2-description__text',
							}),
							Link({
								label: 'Loja',
								href: '/about',
								blockClass: 'footer-desktop-2-description__link',
							}),
						]),
					],
				),
			]),
			FlexLayoutRow(
				{
					blockClass: 'footer-desktop-2-legal-info',
					horizontalAlign: 'between',
					colSizing: 'auto',
				},
				[
					RichText({
						text: '[NOME EMPRESA] LTDA - CNPJ: 00.000.000/0001-00 [RUA OU AVENIDA], 000 - [BAIRRO], [CIDADE] - [UF], CEP 00000-000',
						blockClass: 'footer-desktop-2-legal-text',
					}),
					FlexLayoutRow({ blockClass: 'footer-desktop-2-poweredBy' }, [
						FlexLayoutCol({}, [
							RichText({
								text: 'Powered by',
								blockClass: 'footer-desktop-2-legal-title',
								textAlignment: 'left',
								textPosition: 'left',
							}),
							Image({
								src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-logo-checkout-vtex.png',
								title: 'VTEX',
								link: {
									url: 'https://vtex.com/',
									openNewTab: true,
								},
								blockClass: 'footer-desktop-2',
							}),
						]),
						FlexLayoutCol({}, [
							RichText({
								text: 'Desenvolvido',
								blockClass: 'footer-desktop-2-legal-title',
								textAlignment: 'left',
								textPosition: 'left',
							}),
							Image({
								src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166276-logo-checkout-maeztra.png',
								title: 'Maeztra',
								link: {
									url: 'https://maeztra.com/',
									openNewTab: true,
								},
								blockClass: 'footer-desktop-2',
							}),
						]),
					]),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--footer-desktop-2-background', name: 'Background Color' },
			{ from: '--brand-color-primary-pure', to: '--footer-desktop-2-highlight-color', name: 'Highlight Color' },
			{ from: '--text-color-1', to: '--footer-desktop-2-main-color', name: 'Main Color' },
			{ from: '--brand-color-primary-light', to: '--footer-desktop-2-hover-color', name: 'Hover Color' },
			{ from: '--text-color-1', to: '--footer-desktop-2-legal-text-color', name: 'Legal text color' },
			{ from: '--brand-color-primary-pure', to: '--footer-desktop-2-readmore-color', name: 'Read More Btn' },
			{ from: '--cta-color-pure', to: '--footer-desktop-2-readmore-bc', name: 'Read More Border' },
			//read more body
			{ from: '--brand-color-primary-pure', to: '--footer-desktop-2-readmore-body', name: 'Read More body' },
			{ from: '--brand-color-secondary-pure', to: '--footer-desktop-2-social-color', name: 'Social Media Color' },
		],
	},
	{
		type: 'borderWidth',
		list: [{ from: '--border-width-hairline', to: '--footer-desktop-2-readmore-bw', name: 'Read More' }],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: 0, to: '--footer-2-social-radius', name: 'Social Media Border Radius' },
			{ from: '--border-radius-none', to: '--footer-desktop-2-readmore-br', name: 'Read More' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{
				from: '--font-size-sm',
				to: '--footer-desktop-2-main-size',
				name: 'Main font Size',
			},
		],
	},
	{
		type: 'spacing',
		list: [{ from: '--spacing-atom', to: '--footer-2-social-spacing', name: 'Social Media padding' }],
	},
];
